// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"361":"30f2220e","439":"fffe550a","558":"f95c6c23","976":"4e8a6517"}[chunkId] + ".js";
};